"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VOLUMECHANGE = exports.LOADSTART = exports.CANPLAY = exports.SEEKED = exports.ENDED = exports.PAUSE = exports.PLAY = exports.TIMEUPDATE = void 0;
const TIMEUPDATE = 'timeupdate';
exports.TIMEUPDATE = TIMEUPDATE;
const PLAY = 'play';
exports.PLAY = PLAY;
const PAUSE = 'pause';
exports.PAUSE = PAUSE;
const ENDED = 'ended';
exports.ENDED = ENDED;
const SEEKED = 'seeked';
exports.SEEKED = SEEKED;
const CANPLAY = 'canplay';
exports.CANPLAY = CANPLAY;
const LOADSTART = 'loadstart';
exports.LOADSTART = LOADSTART;
const VOLUMECHANGE = 'volumechange';
exports.VOLUMECHANGE = VOLUMECHANGE;